import template from './waveBg.svg';

export default {
  template,
};
